// Layout.js
import {React, useEffect} from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {  useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import SocketPopup from '../components/SocketPopup';

const Layout = ({ children, hideHeader, hasPermission }) => {
    
    const navigate = useNavigate();
        
    useEffect(() => {
        if (!hasPermission) {
            toast.error("You don't have permssion to access this!");
            navigate(-1); 
        }
    }, [navigate]);

    return (
        <div className="d-flex flex-column flex-root app-root" id='kt_app_root'>
            <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {/* Conditionally render the header based on the hideHeader prop */}
            {!hideHeader && (
                 <div>
                    <Header />
                    <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                        <Sidebar />
                        {children} {/* Render child components here */}
                    </div>
                    <SocketPopup />

                </div>
            )}
            {hideHeader && (
                <main>
                    {children} 
                </main>
            )}


           
            </div>
        </div>
    );
};

export default Layout;
